export enum Environment {
  Production = 'production',
  Staging = 'staging',
  Dev1 = 'dev1',
  Dev2 = 'dev2',
  Dev3 = 'dev3',
  Local = 'local'
}
